import { Injectable } from '@angular/core'; 

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }
  setLocalStorage(key:string, value:any){
    localStorage.setItem(key, JSON.stringify(value));
  }
  getLocalStorage(key:string){
    return JSON.parse(localStorage.getItem(key));
  }

  setSessionStorage(key:string, value:any){
    sessionStorage.setItem(key, JSON.stringify(value));
  }
  getSessionStorage(key:string){
    return JSON.parse(sessionStorage.getItem(key)); 
  }

}
